module.exports = __webpack_public_path__ + "img/20200301_occ_solution_logo.f79b8ebd.png";